import { render, staticRenderFns } from "./BtnPrimary.vue?vue&type=template&id=5343ef76&scoped=true"
import script from "./BtnPrimary.vue?vue&type=script&lang=js"
export * from "./BtnPrimary.vue?vue&type=script&lang=js"
import style0 from "./BtnPrimary.vue?vue&type=style&index=0&id=5343ef76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343ef76",
  null
  
)

export default component.exports